import React, { memo, FC } from "react";
import { singleChallengeProps } from "../../utils/singleChallengeProps";
import { ParticipateButton } from "../challengeCard/SingleChallengeCardButtons";
import { Box, Button, Flex, Heading, Text, Tooltip } from "@radix-ui/themes";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import Participants from "@/components/Participants/Participants";
import i18next from "i18next";

const SingleChallengeGeneralInfo: FC<{
  data: singleChallengeProps;
  isEdit: boolean;
  isPreview: boolean;
  isPrivateForUser: boolean;
}> = ({ data, isEdit, isPreview, isPrivateForUser }): JSX.Element => {
  // Variables
  const ChallengeDescription = data.challengeData.description;
  const isEventSite = brand.event.isEvent;
  const isFinished = data.challengeData.status === "finished";
  const isOngoing = data.challengeData.status === "ongoing";

  return (
    <Flex direction="column" gap="3">
      {/* Button for joining */}
      <Flex>
        {!isPrivateForUser && isOngoing && (
          <Box style={{ width: "100%" }}>
            <ParticipateButton
              data={data}
              isPreview={isPreview || data.challengeData.status !== "ongoing"}
            />
          </Box>
        )}
        {!isPrivateForUser && isFinished && (
          <Box style={{ width: "100%" }}>
            <Tooltip content={i18next.t("challenges.tooltips.finished")}>
              <Button variant="soft" disabled style={{ width: "100%" }}>
                {i18next.t("challenges.status.finished")}
              </Button>
            </Tooltip>
          </Box>
        )}
      </Flex>

      {/* Participants */}
      <Participants
        participantsCount={data.participantsCount}
        lastThreeParticipantsProfiles={data.lastThreeParticipantsProfiles}
        status={data.challengeData.status}
      />

      {/* Description */}
      {ChallengeDescription && !isEventSite && (
        <Box>
          <Heading as="h2" size="4">
            {i18next.t("challenge.description.what.headline")}
          </Heading>
          <Text size="2" as="p">
            {ChallengeDescription}
          </Text>
        </Box>
      )}
    </Flex>
  );
};

export default memo(SingleChallengeGeneralInfo);
